import { Fold, Unfold } from '../Icon/icon'
import style from './ToggleFoldModeBtn.module.scss'

interface SearcherRecentKeywordDisplayToggleButtonProps {
  currentFoldMode: string
  onToggle: () => void
}

const SearcherRecentKeywordDisplayToggleButton = ({
  currentFoldMode,
  onToggle,
}: SearcherRecentKeywordDisplayToggleButtonProps) => {
  return (
    <div>
      <div className={style['toggle-fold-mode-btn-module']}>
        <button
          onClick={() => {
            onToggle()
          }}
        >
          <span className={style['toggle-fold-mode-text']}>
            {currentFoldMode === 'FOLD_MODE_UNFOLDED'
              ? '收合搜尋記錄'
              : '更多搜尋記錄'}
          </span>
        </button>
        <button
          onClick={() => {
            onToggle()
          }}
        >
          {currentFoldMode === 'FOLD_MODE_UNFOLDED' ? <Fold /> : <Unfold />}
        </button>
      </div>
    </div>
  )
}

export default SearcherRecentKeywordDisplayToggleButton
